
import appStoreGoogle from "@/assets/img/app-store-google.svg";
import appStoreApple from "@/assets/img/app-store-apple.svg";


export const AppleBadge = () => {

    return (
        <div className="-storeBadge">
            <a target="_blank" rel="noopener noreferrer"
                href="https://play.google.com/store/apps/details?id=network.further.furtherpass.prod">
                <span>
                    <img src={appStoreGoogle} alt="Get it on Google Play" className="-badge" />
                </span>
            </a>
        </div>
    );
};

export const GoogleBadge = () => {

    return (
        <div className="-storeBadge">
            <a target="_blank" rel="noopener noreferrer"
                href="https://apps.apple.com/app/furtherpass/id1582819895">
                <span>
                    <img src={appStoreApple} alt="Download on the App Store" className="-badge" />
                </span>
            </a>
        </div>
    );
};

export default function StoreBadge() {

    return (
        <div className="-storeBadges">
            <GoogleBadge />
            <AppleBadge />
        </div>
    );
};

